/**
 * @file Manages the fonts values for the theme Modern V1.
 * @author kkumari
 */export default {
  FONT_RUBIK_REGULAR: 'RubikRegular, sans-serif',
  FONT_KARLA_REGULAR: 'KarlaRegular, sans-serif',
  FONT_SIZE_BASE: '16px',
  FONT_SIZE_SMALL: '10px',
  FONT_SIZE_DEFAULT: '14px',
  FONT_LETTER_SPACING_DEFAULT: '1.4px',
  FONT_LINE_HEIGHT_DEFAULT: '18px',
  FONT_ICONS: 'Arial, sans-serif',
  FONT_WEIGHT_BOLD: 'bold',
  FONT_WEIGHT_NORMAL: 'normal',
  //Mobile values
  //H1
  FONT_SIZE_H1: '40px',
  LINE_HEIGHT_H1: '50px',
  LETTER_SPACING_H1: 'normal',
  //H2
  FONT_SIZE_H2: '30px',
  LINE_HEIGHT_H2: '36px',
  LETTER_SPACING_H2: 'normal',
  //H3
  FONT_SIZE_H3: '18px',
  LINE_HEIGHT_H3: '22px',
  LETTER_SPACING_H3: 'normal',
  //H4
  FONT_SIZE_H4: '18px',
  LINE_HEIGHT_H4: '26px',
  LETTER_SPACING_H4: 'normal',
  //H5
  FONT_SIZE_H5: '13px',
  LINE_HEIGHT_H5: '20px',
  LETTER_SPACING_H5: 'normal',
  //P
  FONT_SIZE_P: '16px',
  LINE_HEIGHT_P: '20px',
  LETTER_SPACING_P: '0.32px',
  DESKTOP: {
    //Desktop values
    //H1
    FONT_SIZE_H1: '50px',
    LINE_HEIGHT_H1: '60px',
    LETTER_SPACING_H1: '0.5px',
    //H2
    FONT_SIZE_H2: '38px',
    LINE_HEIGHT_H2: '46px',
    LETTER_SPACING_H2: 'normal',
    //H3
    FONT_SIZE_H3: '26px',
    LINE_HEIGHT_H3: '34px',
    LETTER_SPACING_H3: 'normal',
    //H4
    FONT_SIZE_H4: '20px',
    LINE_HEIGHT_H4: '23px',
    LETTER_SPACING_H4: '0.2px',
    //H5
    FONT_SIZE_H5: '13px',
    LINE_HEIGHT_H5: '15px',
    LETTER_SPACING_H5: 'normal',
    //P
    FONT_SIZE_P: '16px',
    LINE_HEIGHT_P: '30px',
    LETTER_SPACING_P: '0.32px'
  },
  FONT_FACES: ['KarlaRegular', 'RubikRegular']
};